import { render, staticRenderFns } from "./sustainability-module.vue?vue&type=template&id=42793238"
import script from "./sustainability-module.vue?vue&type=script&lang=js"
export * from "./sustainability-module.vue?vue&type=script&lang=js"
import style0 from "./sustainability-module.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports